import { TBoardId, TCardId, TFilterId, TListId } from '../../../../../../types/types';
import { IAsidePanelTab } from '../../types';
import { SegmentCardDetailsCloseSourceValue } from '../../../../../../middlewares/segment/trackEntities/cardEvents';
import { EBoardSetting } from '../../../boardDetails/details/TabDetails/components/TabDetails/types';

export enum EAsidePanelView {
    RELATED = 'RELATED',
}

export enum EAsidePanelProperty {
    CARD_DESCRIPTION = 'CARD_DESCRIPTION',
    CARD_ASSIGNEES = 'CARD_ASSIGNEES',
    CARD_ATTACHMENTS = 'CARD_ATTACHMENTS',
    CARD_CHECKLIST = 'CARD_CHECKLIST',
    CARD_COMMENTS = 'CARD_COMMENTS',
    CARD_CUSTOM = 'CARD_CUSTOM',
    CARD_START_DATE = 'CARD_START_DATE',
    CARD_DUE_DATE = 'CARD_DUE_DATE',
    CARD_DATES = 'CARD_DATES', // old name for migrating
    CARD_DEPENDENCIES = 'CARD_DEPENDENCIES',
    CARD_ESTIMATE = 'CARD_ESTIMATE',
    CARD_MOVETO = 'CARD_MOVETO',
    CARD_NOTIFY = 'CARD_NOTIFY',
    CARD_PRIORITY = 'CARD_PRIORITY',
    CARD_RELATED = 'CARD_RELATED',
    CARD_SUBCARDS = 'CARD_SUBCARDS',
    CARD_TAGS = 'CARD_TAGS',
    CARD_RECURRING = 'CARD_RECURRING'
};

export enum EAsidePanelType {
    CARD_TEMPLATE = 'CARD_TEMPLATE',
};

export type TSubTab = EBoardSetting;

export interface IAsidePanelContext {
    boardId?: TBoardId;
    cardId?: TCardId;
    filterId?: TFilterId;
    getContext?: () => IAsidePanelContext;
    isButtonsFixed?: boolean; // в board settings панель кнопок всегда раскрыта KNB-1098
    isCommentsColumn?: boolean;
    isMobile?: boolean;
    isScrollDisabled?: boolean; // отключает скролл панелек (для открытого попапа проперти, чтобы ничего не прыгало)
    isUserTimeFormat12?: boolean;
    mobileButton?: string;
    listId?: TListId;
    tabs?: ReadonlyArray<IAsidePanelTab>;
    changeTab?: (tabKey: string) => void;
    openedProperty?: EAsidePanelProperty;
    setIsScrollDisabled?: (isScrollDisabled: boolean) => void;
    setOpenedProperty?: (openedProperty: EAsidePanelProperty, isMobile: boolean, isCommentsColumn: boolean) => void;
    tabKey?: string;
    onLoaded?: (key: string, isLoading: boolean) => void;
    type?: EAsidePanelType;
    showedProperties?: Set<EAsidePanelProperty>;
    addShowedProperty?: (property: EAsidePanelProperty, isCommentsColumn: boolean) => void;
    asidePanelWidth?: number;
    subTab?: TSubTab;
    setSubTab?: (subTab: TSubTab) => void;
};

export interface IAsidePanelFields {
    activeTabIndex?: number;
    boardId?: TBoardId;
    cardId?: TCardId;
    children?: any;
    closedRef?: HTMLElement; // куда вернуть фокус перед закрытием
    columnWidth?: number;
    panelActions?: JSX.Element;
    className?: string;
    filterId?: TFilterId;
    footer?: JSX.Element;
    isActionsScticky?: boolean; // actions on top, hide header on scroll
    isActionsMinimized?: boolean;
    isActionsScrollWithBodyDisabled?: boolean;
    isAllowColumnsView?: boolean;
    isButtonsFixed?: boolean;
    isColumnsView?: boolean;
    isFakeRequests?: boolean; // для тестов
    isLeft?: boolean;
    isLoading?: boolean;
    isMobile?: boolean;
    isPrint?: boolean;
    isRequests?: boolean;
    isUserTimeFormat12?: boolean;
    mobileButton?: string;
    listId?: TListId;
    tabs?: ReadonlyArray<IAsidePanelTab>;
    title?: string | JSX.Element;
    titleAction?: JSX.Element;
    type?: EAsidePanelType;
    isForceClosed?: boolean;
    isAssignedToMe?: boolean;
    isAssignedToMeWork?: boolean;
    isCardFromNotification?: boolean;
    asidePanelWidth?: number;
    subTab?: TSubTab;
}

export interface IAsidePanelEvents {
    onClose?: (source?: SegmentCardDetailsCloseSourceValue) => void;
    onTabActive?: (activeTabIndex: number) => void;
    onDidMount?: () => Promise<void>;
    onDidUnmount?: () => void;
    onResize?: (width: number) => void;
    onLoaded?: (key: string) => void;
    onResized?: (width: number) => void;
    onSetColumnView?: (value: boolean) => void;
    onSubTabChange?: (subTab: TSubTab) => void;
}

export interface IAsidePanelProps extends
    IAsidePanelFields,
    IAsidePanelEvents
{}
